<template>
  <main class="settings code d-flex flex-column justify-content-between">
    <div class="actions align-self-stretch">
      <div class="options d-flex flex-column">
        <a
          @click="$router.push('/settings/profile')"
          class="option d-block w-100 d-flex justify-content-between align-items-center"
        >
          <span>{{ $t("Profile") }}</span>
          <i class="fal fa-chevron-right"></i>
        </a>
        <a
          @click="$router.push('/actions')"
          class="option d-block w-100 d-flex justify-content-between align-items-center"
        >
          <span>{{ $t("My actions") }}</span>
          <i class="fal fa-chevron-right"></i>
        </a>
        <a
          target="_blank"
          href="/info/tos"
          class="option d-block w-100 d-flex justify-content-between align-items-center"
        >
          <span>{{ $t("Termini di servizio") }}</span>
          <i class="fal fa-chevron-right"></i>
        </a>
        <a
          target="_blank"
          href="/info/privacy"
          class="option d-block w-100 d-flex justify-content-between align-items-center"
        >
          <span>Privacy Policy</span>
          <i class="fal fa-chevron-right"></i>
        </a>
      </div>
      <div
        class="logout w-100 d-block d-md-none align-self-end"
        style="padding-top: 20px;"
      >
        <div class="container">
          <button
            @click="$store.dispatch('logout')"
            onclick="event.preventDefault();document.getElementById('logout-form').submit();"
            class="btn btn-primary w-100"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Settings"
};
</script>

<style scoped>
.actions .options .option {
  color: #404242;
  text-decoration: none;
  line-height: 65px;
  height: 65px;
  padding: 0 15px;
  border-bottom: 1px solid #ddd;
}
</style>
